module.exports = __webpack_public_path__ + "img/ngo-logo.db22fdd4.png";